// Простая система сигналов для событий

export type Listener<T> = (value: T) => void;

export interface ISignal {
	subscribe(listener: Listener<any>): () => void;

	emit(payload?: any): void;
}

export class Signals {
	public static debug = false;
}

export class Disposer {
	private handlers: (() => void)[] = [];

	public register<T>(signal: Signal<T>, handler: Listener<T>) {
		this.handlers.push(signal.subscribe(handler));
	}

	/** Dispose all signal handlers.
	 *
	 */
	dispose = () => {
		this.handlers.forEach((handler) => handler ? handler() : null);
	}

	registerDisposer(disposer: () => void) {
		this.handlers.push(disposer)
	}
}

export class Signal<T> implements ISignal {
	private listeners: Listener<T>[] = [];
	private lastValue: T | null = null;
	public name: string;

	constructor(name: string) {
		this.name = name;
	}

	subscribe(listener: Listener<T>): () => void {
		this.listeners.push(listener);

		// Немедленно вызываем с последним значением, если есть
		// if (this.lastValue !== null) {
		// 	listener(this.lastValue);
		// }

		// Функция отписки
		return () => {
			const index = this.listeners.indexOf(listener);
			if (index > -1) {
				this.listeners.splice(index, 1);
			}
		};
	}

	emit(value: T): void {
		if (Signals.debug) {
			console.log(`${Date.now()} Signal: ${this.name}`, value);
		}
		this.lastValue = value;
		this.listeners.forEach(listener => listener(value));
	}

	getLastValue(): T | null {
		return this.lastValue;
	}
}